import { render, staticRenderFns } from "./AdvertisementRedirect.vue?vue&type=template&id=01ede45f&scoped=true&"
import script from "./AdvertisementRedirect.vue?vue&type=script&lang=js&"
export * from "./AdvertisementRedirect.vue?vue&type=script&lang=js&"
import style0 from "./AdvertisementRedirect.vue?vue&type=style&index=0&id=01ede45f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ede45f",
  null
  
)

export default component.exports